import { ContentNugget, PanelNugget } from '@backrs_ui/common-ui';

import { nuggetMapper } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavContact } from '@backrs_ui/grow-ui/src/models/models';
import { setCurrentDialogNugget } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

type ContactNuggetProps = Readonly<{
  contact: LubavContact;
  type: 'profile-internal' | 'profile-external';
  disableExpansion?: boolean;
}>;

export const ContactNugget = ({ contact, type, disableExpansion = false }: ContactNuggetProps) => {
  const dispatch = useAppDispatch();
  const { id, relevance, metadata } = contact;
  const { name } = metadata;

  const firstName = name.split(' ')[0] || '';
  const lastName = name.split(' ').slice(1).join(' ') || '';

  const contactNugget: ContentNugget = {
    id: Number(id),
    slug: '',
    title: name,
    description: relevance || '',
    variant: type,
    is_browsable: true,
    star_rating: 0,
    value_rating: 0,
    ...(type === 'profile-internal'
      ? {
          profile_info: {
            id: Number(id),
            first_name: firstName,
            last_name: lastName,
            profile_image: metadata.profile_image || '/profile-pics/default.svg',
            email: '',
            access_token: '',
            ...metadata,
          },
        }
      : {
          external_profile_info: {
            first_name: firstName,
            last_name: lastName,
            url: metadata.link,
            profile_image_url: metadata.profile_image,
            ...metadata,
          },
        }),
  } as ContentNugget;

  return (
    <PanelNugget
      key={metadata.name}
      title={`Profile: ${metadata.name}`}
      subText={relevance}
      variant={nuggetMapper({ nugget: contactNugget })}
      size="SMALL"
      {...(!disableExpansion && { onClick: () => dispatch(setCurrentDialogNugget(contactNugget)) })}
    />
  );
};
